import withURLSearchParamsHandler from "../../../../../../components/hoc/withURLSearchParamsHandler";
import ContractHistory from "./ContractHistory";

const ContractHistoryWithURLSearchParamsHandler = withURLSearchParamsHandler(ContractHistory);
export default ContractHistoryWithURLSearchParamsHandler;